import createAction from 'redux-actions/lib/createAction';

export const skipMfaSetup = createAction('AUTH_SKIP_MFA_SETUP');

export const postponeSetupMfaRequest = createAction('POSTPONE_SETUP_MFA_REQUEST');
export const postponeSetupMfaSuccess = createAction('POSTPONE_SETUP_MFA_SUCCESS');
export const postponeSetupMfaFail = createAction('POSTPONE_SETUP_MFA_FAIL');
